<template>
    <div class="container">
        <div class="row">
            <div class="col col-4">
                <h2 class="h h--2 h--dark">Zamówione nagrody</h2>
                <p class="paragraph">Historia zamówionych przez Ciebie nagród.</p>
            </div>
            <div class="col col-8" v-bind:class="{'pending': pagination.pending}">
                <div v-if="prizes.length > 0">
                  <table class="invoices__table">
                      <tr>
                          <th>nagroda</th>
                          <th>punktów</th>
                          <th>status</th>
                          <th>data dodania</th>
                      </tr>
                      <tr v-for="item in prizes" :key="item.id">  
                          <td>{{ item.orders[0].prize.name }}</td>               
                          <td>{{ item.sum_values }}</td>
                          <td><span class="invoices__status" :class="'invoices__status--' + item.status.id">{{ item.status.name }}</span></td>
                          <td>{{ item.created_at }}</td>
                      </tr>
                  </table>
                  <pagination v-model="pagination.current_page" :page="pagination.current_page" :per-page="parseInt(pagination.per_page)" :records="pagination.total" @paginate="onChangePaginate" v-if="pagination && pagination.last_page > 1"></pagination>
                </div>
                <div class="row profile" v-if="prizes.length == 0">
                    <div class="col col-12">
                        <p>brak zamówionch nagród</p>
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'InstalatorMyPrizesComponent',
  data () {
    return {
      prizes: [],
      pagination: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.axios({
      method: 'get',
      url: '/users/current/ordersHistory'
    })
    .then(response => {
      next(vm => {
        vm.prizes = response.data.data.orders
        vm.pagination = response.data.pagination
      })
    })
    .catch(error => next(false))
  },
  methods: {
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
      if (!this.name) {
        alert('Please enter your name')
      } else {
        this.handleSubmit()
      }
    },
    handleSubmit () {
      this.names.push(this.name)
      this.clearName()
      this.$refs.modal.hide()
    },

    /**
     * On change paginate event.
     * 
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
      let vm = this

      vm.pagination.pending = true

      Vue.axios({
        method: 'get',
        url: '/prizes',
        params: {
          page: page
        }
      })
      .then(response => {
        vm.prizes = response.data.data.prizes
        vm.pagination = response.data.pagination
      })
      .catch(error => pagination.pending = false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/instalatorPrizes/InstalatorMyPrizesComponent.vue